import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { BaseMaintenanceController } from '../_base/BaseMaintenanceController';
import { TenantImageItemMaintenanceDto } from './TenantImageItemMaintenanceDto';
import { TenantImageListMaintenanceDto } from './TenantImageListMaintenanceDto';

@Injectable()
export class TenantImageMaintenanceController extends BaseMaintenanceController<TenantImageListMaintenanceDto, TenantImageItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "tenantimage");
    }

    public getResourceRoot(): string {
        return "TENANTIMAGE";
    }

    public buildUrl(uri: string): string {
        return "system/dataandparameters/tenantimage" + uri;
    }
}
